import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "reEnrolment",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-enrollment" */ "Admissions/features/Enrollment/components/ReEnrolment"
    ).then(m => m.default)
  ),
});
